document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("fp-layaway-modal-id");
  const cancelBtn = document.querySelector(".fp-layaway-cancel");
  const checkoutBtn = document.querySelector(".fp-layaway-checkout");
  const downpaymentInput = document.getElementById("downpayment-amount");
  const downpaymentInputWrapper = document.querySelector(".fp-layaway-modal__input-wrapper");
  const remainingBalanceElement = document.querySelector(".fp-layaway-modal__balance-amount");
  const layawayDueDate = document.getElementById("fp-layaway-due-date");
  const checkoutText = document.getElementById("fp-layaway-checkout-text");
  const processingText = document.getElementById("fp-layaway-processing-text");
  const layawayAgreementCheckbox = document.getElementById("layaway-agreement");
  const reserveTotals = document.querySelectorAll(".fp-summary-item__total");
  const dueTodayValue = document.querySelector(".fp-summary-item__due-today-val");
  const agreementBox = document.querySelector(".fp-layaway-modal__agreement");
  const agreementError = document.getElementById("layaway-agreement-error");
  const downpaymentRequirementInfo = document.getElementById("fp-downpayment-info");
  const lowDownpaymentErr = document.getElementById("fp-downpayment-error-low");
  const highDownpaymentErr = document.getElementById("fp-downpayment-error-high");
  const modalCloseBtn = document.getElementById("fp-layaway-modal-close-btn");
  const downpaymentDisclaimer = document.getElementById("fp-layaway-modal__disclaimer-text");
  const reserveErrorBox = document.getElementById("fp-layaway-checkout-error");

  if (
    !modal ||
    !downpaymentInput ||
    !checkoutBtn ||
    !cancelBtn ||
    !remainingBalanceElement ||
    !layawayDueDate ||
    !layawayAgreementCheckbox ||
    !downpaymentDisclaimer
  ) {
    console.error("Layaway Modal Error: Missing required HTML elements.");
    return;
  }

  let currentDownpayment = 0;
  let productPrice = 0;
  let minDownpayment = 0;
  let maxDownpayment = 0;
  let productId = null;
  let customerEmail = null;
  const shopCurrency = window.shopCurrency || "USD";
  const userLocale = navigator.language || "en-US";
  const ua = navigator.userAgent || "";
  const isMobileApp = ua.includes("XFPAPP") || ua.includes("ShopifyCheckoutSDK");
  const shopDomain = window.shopDomain || "";
  const storefrontToken = window.storefrontToken;
  const today = new Date();
  const dueDate = new Date(today.setDate(today.getDate() + 60));
  const dateOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  let remainingBalance = 0;
  const formattedDueDate = dueDate.toLocaleDateString(undefined, dateOptions);
  layawayDueDate.textContent = formattedDueDate;

  const downpaymentDisclaimerText = downpaymentDisclaimer.innerHTML;
  downpaymentDisclaimer.innerHTML = downpaymentDisclaimerText.replace("DOWNPAYMENT", '<span id="fp-dp-val"></span>');

  document.body.addEventListener("click", function (event) {
    const button = event.target.closest(".fp-layaway-button");
    if (!button) {
      return;
    }

    event.preventDefault();

    const productPriceAttr = button.dataset.productPrice;
    const downpaymentAttr = button.dataset.downpayment;
    const productIdAttr = button.dataset.productId;
    const customerEmailAttr = button.dataset.customerEmail;

    if (!productPriceAttr || !downpaymentAttr) {
      console.error("Missing data attributes on layaway button.");
      return;
    }

    productPrice = parseFloat(productPriceAttr);
    const downpayment = parseFloat(downpaymentAttr).toFixed(2);
    const balance = (productPrice - downpayment).toFixed(2);
    const disclaimerDp = document.getElementById("fp-dp-val");

    downpaymentInput.value = downpayment;
    downpaymentInput.min = downpayment;
    downpaymentInput.max = productPrice;
    minDownpayment = downpayment;
    maxDownpayment = productPrice;
    currentDownpayment = downpayment;
    setRemainingBalance(balance);
    remainingBalance = getRemainingBalance();
    productId = productIdAttr;
    customerEmail = customerEmailAttr;

    reserveTotals.forEach((el) => {
      el.textContent = `$${productPrice.toFixed(2)}`;
    });
    dueTodayValue.textContent = `$${currentDownpayment}`;
    disclaimerDp.textContent = `$${downpayment}`;

    modal.classList.add("fp-layaway-modal--open");
  });

  function closeLayawayModal() {
    modal.classList.remove("fp-layaway-modal--open");
    resetModal();
  }

  cancelBtn.addEventListener("click", closeLayawayModal);
  modalCloseBtn.addEventListener("click", closeLayawayModal);

  function validateDownpayment() {
    minDownpayment = parseFloat(downpaymentInput.min);
    maxDownpayment = parseFloat(downpaymentInput.max);
    if (!minDownpayment || !maxDownpayment) {
      return false;
    }

    currentDownpayment = parseFloat(downpaymentInput.value);
    if (isNaN(currentDownpayment)) {
      downpaymentInputWrapper.classList.add("input-error");
      downpaymentRequirementInfo.classList.add("hidden");
      highDownpaymentErr.classList.add("hidden");
      lowDownpaymentErr.classList.remove("hidden");
      return false;
    }

    const isTooLow = currentDownpayment < minDownpayment;
    const isTooHigh = maxDownpayment - currentDownpayment < 1;

    if (isTooLow || isTooHigh) {
      downpaymentInputWrapper.classList.add("input-error");
      downpaymentRequirementInfo.classList.add("hidden");

      if (isTooLow) {
        highDownpaymentErr.classList.add("hidden");
        lowDownpaymentErr.classList.remove("hidden");
        return false;
      }

      if (isTooHigh) {
        lowDownpaymentErr.classList.add("hidden");
        highDownpaymentErr.classList.remove("hidden");
        return false;
      }
    }

    downpaymentInputWrapper.classList.remove("input-error");
    downpaymentRequirementInfo.classList.remove("hidden");
    lowDownpaymentErr.classList.add("hidden");
    highDownpaymentErr.classList.add("hidden");

    return true;
  }
  function getRemainingBalance() {
    return productPrice - currentDownpayment;
  }
  function resetCheckoutButton() {
    checkoutBtn.disabled = false;
    checkoutText.style.display = "inline";
    processingText.style.display = "none";
  }

  function resetModal() {
    layawayAgreementCheckbox.checked = false;
    agreementBox.classList.remove("error-border");
    agreementError.classList.add("hidden");

    downpaymentInput.value = parseFloat(minDownpayment).toFixed(2);
    downpaymentInputWrapper.classList.remove("input-error");
    downpaymentRequirementInfo.classList.remove("hidden");
    lowDownpaymentErr.classList.add("hidden");
    highDownpaymentErr.classList.add("hidden");
    resetCheckoutButton();
  }

  function setRemainingBalance(amount) {
    remainingBalanceElement.textContent = new Intl.NumberFormat(userLocale, {
      style: "currency",
      currency: shopCurrency,
    }).format(amount);
  }

  function setReserveCheckoutError(msg) {
    const errorMsgEl = reserveErrorBox.querySelector(".fp-layaway-checkout-error__text");
    errorMsgEl.textContent = msg;
    reserveErrorBox.classList.remove("hidden");
  }

  function clearReserveCheckoutError() {
    const errorMsgEl = reserveErrorBox.querySelector(".fp-layaway-checkout-error__text");
    errorMsgEl.textContent = "";
    reserveErrorBox.classList.add("hidden");
  }

  downpaymentInput.addEventListener("keydown", function (event) {
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];

    // Allow: Ctrl/Cmd + A/C/V/X/Z
    if ((event.ctrlKey || event.metaKey) && ["a", "c", "v", "x", "z"].includes(event.key.toLowerCase())) {
      return;
    }

    // Allow numbers and period
    if (/^[0-9.]$/.test(event.key)) {
      return;
    }
    // Allow navigation and editing keys
    if (allowedKeys.includes(event.key)) {
      return;
    }

    // Block everything else
    event.preventDefault();
  });

  downpaymentInput.addEventListener("input", function () {
    const isValid = validateDownpayment();
    const value = parseFloat(downpaymentInput.value);
    if (isValid) {
      remainingBalance = getRemainingBalance();
      setRemainingBalance(remainingBalance);
      dueTodayValue.textContent = `$${value.toFixed(2)}`;
    }
  });
  downpaymentInput.addEventListener("blur", () => {
    const value = parseFloat(downpaymentInput.value);
    if (!isNaN(value)) {
      downpaymentInput.value = value.toFixed(2);
      validateDownpayment();
    }
  });

  layawayAgreementCheckbox.addEventListener("change", function () {
    agreementBox.classList.remove("error-border");
    agreementError.classList.add("hidden");
  });

  function callReservePaymentEvent() {
    // Only run in XFPAPP
    if (!navigator.userAgent.includes("XFPAPP")) return;
    const cartId = getCartIdFromCookie();
    const payload = {
      action: "open",
      data: {
        cartId: cartId || "",
      },
    };

    if (window.flutter_inappwebview) {
      flutterChannelCall("reserve-payment", payload);
    } else {
      window.addEventListener(
        "flutterInAppWebViewPlatformReady",
        () => flutterChannelCall("reserve-payment", payload),
        { once: true },
      );
    }
  }

  checkoutBtn.addEventListener("click", function () {
    clearReserveCheckoutError();
    callReservePaymentEvent();
    checkoutBtn.disabled = true;
    checkoutText.style.display = "none";
    processingText.style.display = "inline";
    if (!layawayAgreementCheckbox.checked) {
      resetCheckoutButton();
      agreementBox.classList.add("error-border");
      agreementError.classList.remove("hidden");
      return;
    }
    const isValid = validateDownpayment();
    if (!isValid || !productId || !customerEmail) {
      resetCheckoutButton();
      return;
    }
    const variantId = `gid://shopify/ProductVariant/${productId}`;

    const url = `https://${shopDomain}/api/2025-04/graphql.json`;

    const query = `
      mutation CreateCart($lines: [CartLineInput!], $buyerIdentity: CartBuyerIdentityInput, $attributes: [AttributeInput!]) {
        cartCreate(input: { lines: $lines, buyerIdentity: $buyerIdentity, attributes: $attributes}) {
          cart {
            id
            checkoutUrl
            cost {
              totalAmount {
                amount
              }
            }
            attributes {
              key
              value
            }
          }
          userErrors {
            field
            message
          }
        }
      }`;

    const variables = {
      lines: [
        {
          quantity: 1,
          merchandiseId: variantId,
        },
      ],
      buyerIdentity: {
        email: customerEmail,
      },
      attributes: [
        {
          key: "is_reserve",
          value: "true",
        },
        {
          key: "layaway_deposit",
          value: currentDownpayment.toString(),
        },
        {
          key: "remaining_balance",
          value: parseFloat(remainingBalance).toFixed(2).toString(),
        },
        {
          key: "due_date",
          value: dueDate,
        },
        {
          key: "product_original_price",
          value: productPrice.toString(),
        },
        {
          key: "is_mobile_app",
          value: isMobileApp ? "true" : "false",
        },
      ],
    };

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": storefrontToken,
      },
      body: JSON.stringify({ query, variables }),
    })
      .then((res) => res.json())
      .then((data) => {
        const cart = data.data.cartCreate.cart;
        if (cart) {
          window.location.href = cart.checkoutUrl;
        } else {
          resetModal();
          setReserveCheckoutError("Something went wrong. Please try again.");
          console.error("Error creating cart:", data);
        }
      })
      .catch((error) => {
        resetModal();
        setReserveCheckoutError("Something went wrong. Please try again.");
        console.error("API Error:", error);
      });
  });
});
